module.exports = __webpack_public_path__ + "img/image-our-story-academy-template-p-1080.ff5cc475.jpeg";